module.exports = __webpack_public_path__ + "media/images/lalamove-58cc4b4975d57119a5814d5cc57c9a37.png";